<div class="logo-loader" id="logo-loader">
  <div class="logo-loader__overlay">
    <img class="logo-loader__img" [src]="'assets/images/logo.svg'" alt="logo"/>
    <div class="logo-loader__loading"></div>
  </div>
  @if (text) {
    <div id="logo-loader__text" class="logo-loader__text">{{text}}</div>
  }
</div>
